import {Debugger} from "debug";
import {CriiptoBindBrukerFeiletForsøk, CriiptoBindBrukerFeiletForsøkÅrsak, CriiptoBindFraTokenSesjonstjeneste} from "web/tjenester/CriiptoBindFraTokenSesjonstjeneste";

const debug: Debugger = require('debug')('CriiptoBindBrukerFeiletKontroller');

const delt_scss = require('./delt.scss');
const forside_scss = require('./forside.scss');
const logginn_scss = require('./logginn.scss');

/**
 * Håndterer binding av bruker til openid subject returnert av criipto.
 */
export class CriiptoBindBrukerFeiletKontroller {

    static regNavn = "web.CriiptoBindBrukerFeiletKontroller";
    private data: CriiptoBindBrukerFeiletForsøk;

    static forInjisering() {
        return [
            CriiptoBindFraTokenSesjonstjeneste.regNavn,
            CriiptoBindBrukerFeiletKontroller
        ]
    }

    constructor(criiptoBindFraTokenSesjonstjeneste: CriiptoBindFraTokenSesjonstjeneste) {
        this.data = criiptoBindFraTokenSesjonstjeneste.feiletForsøkInformasjon();
    }

    aarsak(): CriiptoBindBrukerFeiletForsøkÅrsak {
        return this.data.aarsak;
    }

    feiletPgaEpost(): boolean {
        return this.aarsak() == CriiptoBindBrukerFeiletForsøkÅrsak.annenBrukerKnyttetTilAngittEid
    }

    feiletPgaBankId(): boolean {
        return this.aarsak() == CriiptoBindBrukerFeiletForsøkÅrsak.brukerAlleredeKnyttetTilEid
    }

    epostBundet(): string {
        return this.data.epost_bundet ?? "";
    }
    epostForsoekt(): string {
        return this.data.epost_forsoekt ?? "";
    }
}
